import { FC } from 'react'
import { Link } from 'react-router-dom'
import { IconPaths, IconSize } from '../../../../../../../_metronic/helpers/enumsUI'
import { KTSVG } from '../../../../../../../_metronic/helpers/components/KTSVG'
import { PageHeading } from '../../../../../../components/Header/PageHeading'
import { SituacaoProtocoloBadge } from '../../../components/SituacaoProtocoloBadge'
import { CLASSE_LINK_OUTLINE } from '../../../core/classeLinkOutline'
import { ModeloVersaoDetalhe } from '../../../core/_models'
import { rotaDetalheModelo } from '../../modelo-plataforma-list/core/rotas'

type Props = {
  versao?: ModeloVersaoDetalhe
  idVersao: number
}

/**
 * Cabeçalho da comparação do modelo (mesmo formato da comparação do protocolo): a versão
 * comparada como título, situação como apoio e o caminho de volta para essa versão.
 */
export const ModeloPlataformaComparacaoHeading: FC<Props> = ({ versao, idVersao }) => (
  <PageHeading
    title={
      versao
        ? `Comparar a versão ${versao.versao} do modelo — ${versao.nome}`
        : 'Comparar versões do modelo'
    }
    description={
      versao && (
        <span className='d-inline-flex flex-wrap align-items-center gap-3'>
          <SituacaoProtocoloBadge situacao={versao.situacao} escopo='modelo' />
          <span>Escolha com qual versão comparar.</span>
        </span>
      )
    }
    actions={
      <Link className={CLASSE_LINK_OUTLINE} to={rotaDetalheModelo(idVersao)}>
        <span className='me-2 d-flex align-items-center' aria-hidden='true'>
          <KTSVG path={IconPaths.ArrowLeft} size={IconSize.ExtraSmall} />
        </span>
        {versao ? `Voltar para a versão ${versao.versao}` : 'Voltar para a versão'}
      </Link>
    }
  />
)
